export default "__VITE_ASSET__BotQWguS__"